import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import type { SmartBrandsPropsType } from './grid-banner-app'

import './genericgridbrand.scss'

type ResponsiveImages = {
  alt: string
  redirectUrl: string
  srcSet: string
}

const GenericGridBanner = ({ mobile, desktop }: SmartBrandsPropsType) => {
  const { isMobile } = useBreakpoint()
  const mobileData = mobile?.sources
  const desktopData = desktop?.sources
  const deviceData = isMobile ? mobileData : desktopData

  return (
    <>
      <div className="allBrands__container">
        <div
          className={`${
            !isMobile
              ? 'brandsGrid-container'
              : 'mobileBrands__carrousel-container'
          }`}
        >
          {deviceData?.map((image: ResponsiveImages, index: number) => (
            <div
              className={`${
                !isMobile ? 'gridImage-container' : 'carrousel-image-container'
              }`}
              key={index}
            >
              <a href={image?.redirectUrl}>
                <img src={image.srcSet} loading="lazy" alt={image.alt} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default GenericGridBanner
